import { useTranslation } from 'react-i18next';

declare const window: Window &
    typeof globalThis & {
        ENV: {
            CMS_MAPPING: {
                [article: string]: {
                    [language: string]: string;
                };
            };
        };
    };

export const useHelpCenterLink = () => {
    const [, { language }] = useTranslation();
    const CMS_MAPPING = window?.ENV?.CMS_MAPPING ?? {};
    const HELP_CENTER_URL = 'https://help.useme.com/';

    return {
        helpCenterLink: (article: string) => {
            if (!Object.prototype.hasOwnProperty.call(CMS_MAPPING, article)) {
                return HELP_CENTER_URL + CMS_MAPPING?.['']?.[language];
            }

            return HELP_CENTER_URL + CMS_MAPPING?.[article]?.[language];
        },
    };
};
